module.exports = __webpack_public_path__ + "img/delivery.f19d188b.svg";